import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtilityService } from '../utility.service';
import { HttpClient } from '@angular/common/http';
import { BaseFormService } from '../BaseFormService';

@Injectable({
	providedIn: 'root',
})
export class VendorCreditMemoService extends BaseFormService {
	private showDuplicateMemoNumberPopup = new BehaviorSubject<boolean>(false);

	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}forms/clients/$$clientId$$/vendor-credit-memo-form`, httpClient, utilityService);
	}
	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	changeStatus(clientId: string, id: string) {
		return this.httpClient.get<any>(`${this.getUrl(clientId)}/${id}/change-status`).pipe();
	}
	getAllMemos(clientId: string, type: any, vendorId: any, paymentFormId: any) {
		return this.httpClient
			.get<any>(`${this.getUrl(clientId)}/${type}/${vendorId}/search?paymentFormId=${paymentFormId}`)
			.pipe();
	}

	getMemoById(clientId: string, id: any) {
		return this.httpClient.get<any>(`${this.getUrl(clientId)}/${id}`).pipe();
	}

	searchForDuplicate(clientId: string, memoNumber: string): Observable<any> {
		return this.httpClient
			.get<any>(`${this.getUrl(clientId)}/search-duplicate/${encodeURIComponent(memoNumber)}`)
			.pipe();
	}

	showDuplicateMemoNumberPopupChange$ = this.showDuplicateMemoNumberPopup.asObservable();
	setShowDuplicateInvoicePopup(value: boolean) {
		this.showDuplicateMemoNumberPopup.next(value);
	}

	getAvailableForPartialUsage(
		clientId: string,
		vendorId?: string,
		formId?: string,
		includePartiallyUsed = false
	): Observable<any> {
		let params = '';
		if (vendorId || formId || includePartiallyUsed) {
			const queryParams = [];
			if (vendorId) {
				queryParams.push(`vendorId=${vendorId}`);
			}
			if (formId) {
				queryParams.push(`formId=${formId}`);
			}
			if (includePartiallyUsed) {
				queryParams.push('includePartiallyUsed=true');
			}
			params = '?' + queryParams.join('&');
		}
		return this.httpClient.get<any>(`${this.getUrl(clientId)}/available-for-partial-usage${params}`).pipe();
	}

	getRemainingBalance(clientId: string, accountId: number, formId?: string): Observable<any> {
		let url = `${this.getUrl(clientId)}/account/${accountId}/remaining-balance`;
		if (formId) {
			url += `?formId=${formId}`;
		}
		return this.httpClient.get<any>(url).pipe();
	}

	validatePartialUsage(clientId: string, vendorCreditMemoAccountId: number, amount: number): Observable<any> {
		return this.httpClient
			.get<any>(
				`${this.getUrl(
					clientId
				)}/validate-partial-usage?vendorCreditMemoAccountId=${vendorCreditMemoAccountId}&amount=${amount}`
			)
			.pipe();
	}
}
